document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll(
    '.nobull-footer #footer-newsletter, .footer-newsletter-card__form'
  );

  // Function to validate email input
  function validateInput(input, errorMessage, message) {
    if (!input || !input.checkValidity() || input.value.trim() === '') {
      if (errorMessage) {
        errorMessage.textContent = message; // Show error message
        errorMessage.classList.remove('hidden'); // Unhide the error message
      }
      return false;
    } else {
      if (errorMessage) {
        errorMessage.classList.add('hidden'); // Hide the error message if input is valid
      }
      return true;
    }
  }

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const emailInput = form.querySelector('input[type="email"]');
      const inputGroup = form.querySelector(
        '.footer-newsletter-input-group, .footer-newsletter-card__input-group'
      );
      const footerFormBtn = form.querySelector(
        '.footer-column--news-btn-icon, .footer-newsletter-card__submit'
      );
      const agreeText = form.querySelector(
        '.footer-column--news-agree-text, .footer-newsletter-card__agree-text'
      );
      const emailErrorMessage = form.querySelector(
        '.error-message-email, .footer-newsletter-card__error'
      );
      const thankYouMessage = form.querySelector(
        '.thankyou-message, .footer-newsletter-card__success'
      );
      const emersysApiURL =
        form.querySelector('#EmarsysAPIURL')?.value ||
        document.querySelector('#EmarsysAPIURL')?.value;

      let isValid = validateInput(
        emailInput,
        emailErrorMessage,
        'Please enter a valid email address.', // Error message for invalid email
      );

      if (isValid) {
        try {
          // Segment Analytics - Identify call (must happen before Track call)
          if (window.analytics && typeof window.analytics.identify === 'function') {
            window.analytics.identify({
              email: emailInput.value
            });
          }

          // Segment Analytics - Track call for newsletter subscription
          if (window.analytics && typeof window.analytics.track === 'function') {
            window.analytics.track('Newsletter Subscribed', {
              form_type: 'newsletter',
              form_location: 'footer',
              email: emailInput.value,
              opt_in_source: 'website',
              opt_source_detail: 'footer',
              form_details: [
                { field: 'email', value: emailInput.value },
                { field: 'opt_in_source', value: 'website' },
                { field: 'opt_source_detail', value: 'footer' },
                { field: 'form_type', value: 'newsletter' },
                { field: 'email', value: emailInput.value } // This matches the batch[0].properties.form_details[4].value pattern
              ]
            });
          }
          
          if (emersysApiURL) {
            // API call to Emarsys create-contact endpoint
            const options = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'api-key': 'eabfeb7d-5a60-4a7f-b151-c7715be9e1f8', // Replace with your actual API key
              },
              body: JSON.stringify({
                email: emailInput.value,
                firstname: '',
                lastname: '',
                shopify_opt: '1',
                opt_in_source: 'website',
                opt_source_detail: 'footer',
              }),
            };

            const response = await fetch(
              `${emersysApiURL}/create-contact`,
              options,
            );

            if (response.ok) {
              // On success: hide email input, show thank you message
              if (emailInput) emailInput.classList.add('hidden');
              if (inputGroup) inputGroup.classList.add('hidden');
              if (footerFormBtn) footerFormBtn.classList.add('hidden');
              if (agreeText) agreeText.classList.add('hidden');
              if (thankYouMessage) {
                thankYouMessage.classList.remove('hidden');
                thankYouMessage.classList.add('flex');
                thankYouMessage.style.display = 'block';
              }
              if (emailErrorMessage) emailErrorMessage.classList.add('hidden');
            } else {
              throw new Error('Network error occurred'); // Handle API error
            }
          } else {
            // Fallback success display when emersysApiURL is not set
            if (emailInput) emailInput.classList.add('hidden');
            if (inputGroup) inputGroup.classList.add('hidden');
            if (footerFormBtn) footerFormBtn.classList.add('hidden');
            if (agreeText) agreeText.classList.add('hidden');
            if (thankYouMessage) {
              thankYouMessage.classList.remove('hidden');
              thankYouMessage.classList.add('flex');
              thankYouMessage.style.display = 'block';
            }
            if (emailErrorMessage) emailErrorMessage.classList.add('hidden');
          }
        } catch (error) {
          if (emailErrorMessage) {
            emailErrorMessage.textContent =
              'An error occurred. Please try again.';
            emailErrorMessage.classList.remove('hidden'); // Show error message
          }
        }
      }
    });
  });

  // Footer collapse functionality
  const footerColumns = document.querySelectorAll(
    '.footer-column--nav',
  );

  footerColumns.forEach((column) => {
    const columnHeader = column.querySelector('.footer-column--nav-header');
    
    columnHeader.addEventListener('click', () => {
      const isActive = column.classList.contains('active');

      // Only one column can stay open at a time
      footerColumns.forEach((otherColumn) => {
        if (otherColumn !== column) {
          otherColumn.classList.remove('active');
        }
      });

      if (!isActive) {
        column.classList.add('active');
      } else {
        column.classList.remove('active');
      }
    });
  });
});
